import PreUndoData from "./PreUndoData";
import * as _ from 'lodash'
import WaypointSerialization from "./WaypointSerialization";

export default class RestoreWaypointData extends PreUndoData {
    constructor(waypointId: string, waypointSerialization: WaypointSerialization) {
        super()
        this.serialization = _.cloneDeep(waypointSerialization) // if we don't clone, then if the array gets reversed, the copy in here will get reversed too, which we don't want
    }
    serialization: WaypointSerialization
}